export const GET_ALL_TEA_CONFIGS = 'common-data/GET_ALL_TEA_CONFIGS';
export const GET_ALL_SEVERITY_OF_HARM_VALUES = 'common-data/GET_ALL_SEVERITY_OF_HARM_VALUES';
export const GET_ALL_QC_RULES_VALUES = 'common-data/GET_ALL_QC_RULES_VALUES';
export const GET_ALL_DATE_RANGE_VALUES = 'common-data/GET_ALL_DATE_RANGE_VALUES';
export const GET_ALL_GROUP_TYPES = 'common-data/GET_ALL_GROUP_TYPES';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/common-data/common-data.action.const.ts